module.exports = __webpack_public_path__ + "img/overview.a9202e20.svg";